import { render, staticRenderFns } from "./partyGroupList.vue?vue&type=template&id=274aae1c"
import script from "./partyGroupList.vue?vue&type=script&lang=js"
export * from "./partyGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports